'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = require('redux-async-connect');

var _background = require('redux/modules/background');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WSLP = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    // console.log(params);
    promises.push(dispatch((0, _background.changeHeaderText)('外事礼品')));
    return _promise2.default.all(promises);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WSLP, _Component);

  function WSLP() {
    (0, _classCallCheck3.default)(this, WSLP);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(WSLP).call(this));
  }

  (0, _createClass3.default)(WSLP, [{
    key: 'render',
    value: function render() {
      var styles = require('./WSLP.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/wslp/content.jpg',
          alt: '' }),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return WSLP;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object
}, _temp)) || _class);
exports.default = WSLP;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/WSLP/WSLP.js
 ** module id = 1550
 ** module chunks = 0
 **/